import { sellerConstants } from '../_constants';
import { sellerService } from '../_services';

export const sellerActions = {
    getSellers,


    addData
};



function getSellers() {
    return dispatch => {
        dispatch(request());
        sellerService.getSellers()
            .then(
                sellers => {
                    dispatch(success(sellers));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: sellerConstants.REQUEST_SELLERS } }
    function success(sellers) { return { type: sellerConstants.RECEIVE_SELLERS, sellers } }
    function failure(error) { return { type: sellerConstants.SELLER_ERROR, error } }
}


// Add new seller
function addData(data) {
    return dispatch => {
        dispatch(request(data));
        sellerService.addSeller(data)
            .then(
                response => {
                    dispatch(sellerActions.getSellers());
                    dispatch(success(response));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request(data) { return { type: sellerConstants.ADD_SELLER_REQUEST, data } }
    function success(sellers) { return { type: sellerConstants.ADD_SELLER_SUCCESS, sellers } }
    function failure(error) { return { type: sellerConstants.ADD_SELLER_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/seller.actions.js